import React from 'react'
import * as S from './style'

const VoidIcon = () => {
    return (
        <S.VoidIcon />
    )
}

export default VoidIcon